export const lengthUnit =
{
  "mm": {
    "value": "mm",
    "label": "mm - Millimeter",
    "groupBy": "Metric System",
    "displayName" : "mm"
  },
  "cm": {
    "value": "cm",
    "label": "cm - Centimeter",
    "groupBy": "Metric System",
    "displayName" : "cm"
  },
  "inch": {
    "value": "inch",
    "label": "Inch",
    "groupBy": "Imperial System",
    "displayName" : "inch"
  },
  "m": {
    "value": "m",
    "label": "m - Meter",
    "groupBy": "Metric System",
    "displayName" : "m"
  },
  "ft": {
    "value": "ft",
    "label": "ft - Feet",
    "groupBy": "Imperial System",
    "displayName": "ft",
  }
}

export const weightUnit =
{
  "g": {
    "value": "g",
    "label": "g - Gram",
    "groupBy": "Metric System",
    "displayName" : "g"
  },
  "kg": {
    "value": "kg",
    "label": "kg - Kilogram",
    "groupBy": "Metric System",
    "displayName" : "kg"
  },
  "t": {
    "value": "t",
    "label": "t - Metric Tonne",
    "groupBy": "Metric System",
    "displayName" : "t"
  },
  "ton": {
    "value": "ton",
    "label": "US - Ton - Short Ton",
    "groupBy": "Imperial System",
    "displayName" : "US - Ton"
  },
  "imperial_ton": {
    "value": "imperial_ton",
    "label": "Ton - Imperial Ton",
    "groupBy": "Imperial System",
    "displayName" : "ton"
  },
  "lb": {
    "value": "lb",
    "label": "lb - Pound",
    "groupBy": "Imperial System",
    "displayName": "lb",
  }
}

export const currency_List = [
  {
    name: "United Arab Emirates Dirham",
    code: "AED",
    symbol: "د.إ",
    displayName: "AED - United Arab Emirates Dirham",
  },
  {
    name: "Afghan Afghani",
    code: "AFN",
    symbol: "؋",
    displayName: "AFN - Afghan Afghani",
  },
  {
    name: "Albanian Lek",
    code: "ALL",
    symbol: "L",
    displayName: "ALL - Albanian Lek",
  },
  {
    name: "Armenian Dram",
    code: "AMD",
    symbol: "֏",
    displayName: "AMD - Armenian Dram",
  },
  {
    name: "Netherlands Antillean Guilder",
    code: "ANG",
    symbol: "ƒ",
    displayName: "ANG - Netherlands Antillean Guilder",
  },
  {
    name: "Angolan Kwanza",
    code: "AOA",
    symbol: "Kz",
    displayName: "AOA - Angolan Kwanza",
  },
  {
    name: "Argentine Peso",
    code: "ARS",
    symbol: "$",
    displayName: "ARS - Argentine Peso",
  },
  {
    name: "Australian Dollar",
    code: "AUD",
    symbol: "$",
    displayName: "AUD - Australian Dollar",
  },
  {
    name: "Aruban Florin",
    code: "AWG",
    symbol: "ƒ",
    displayName: "AWG - Aruban Florin",
  },
  {
    name: "Azerbaijani Manat",
    code: "AZN",
    symbol: "₼",
    displayName: "AZN - Azerbaijani Manat",
  },
  {
    name: "Bosnia-Herzegovina Convertible Mark",
    code: "BAM",
    symbol: "KM",
    displayName: "BAM - Bosnia-Herzegovina Convertible Mark",
  },
  {
    name: "Barbadian Dollar",
    code: "BBD",
    symbol: "$",
    displayName: "BBD - Barbadian Dollar",
  },
  {
    name: "Bangladeshi Taka",
    code: "BDT",
    symbol: "৳",
    displayName: "BDT - Bangladeshi Taka",
  },
  {
    name: "Bulgarian Lev",
    code: "BGN",
    symbol: "лв",
    displayName: "BGN - Bulgarian Lev",
  },
  {
    name: "Bahraini Dinar",
    code: "BHD",
    symbol: ".د.ب",
    displayName: "BHD - Bahraini Dinar",
  },
  {
    name: "Burundian Franc",
    code: "BIF",
    symbol: "FBu",
    displayName: "BIF - Burundian Franc",
  },
  {
    name: "Bermudan Dollar",
    code: "BMD",
    symbol: "$",
    displayName: "BMD - Bermudan Dollar",
  },
  {
    name: "Brunei Dollar",
    code: "BND",
    symbol: "$",
    displayName: "BND - Brunei Dollar",
  },
  {
    name: "Bolivian Boliviano",
    code: "BOB",
    symbol: "Bs.",
    displayName: "BOB - Bolivian Boliviano",
  },
  {
    name: "Brazilian Real",
    code: "BRL",
    symbol: "R$",
    displayName: "BRL - Brazilian Real",
  },
  {
    name: "Bahamian Dollar",
    code: "BSD",
    symbol: "$",
    displayName: "BSD - Bahamian Dollar",
  },
  { name: "Bitcoin", code: "BTC", symbol: "₿", displayName: "BTC - Bitcoin" },
  {
    name: "Bhutanese Ngultrum",
    code: "BTN",
    symbol: "Nu.",
    displayName: "BTN - Bhutanese Ngultrum",
  },
  {
    name: "Botswanan Pula",
    code: "BWP",
    symbol: "P",
    displayName: "BWP - Botswanan Pula",
  },
  {
    name: "Belarusian Ruble",
    code: "BYN",
    symbol: "Br",
    displayName: "BYN - Belarusian Ruble",
  },
  {
    name: "Belize Dollar",
    code: "BZD",
    symbol: "BZ$",
    displayName: "BZD - Belize Dollar",
  },
  {
    name: "Canadian Dollar",
    code: "CAD",
    symbol: "$",
    displayName: "CAD - Canadian Dollar",
  },
  {
    name: "Congolese Franc",
    code: "CDF",
    symbol: "FC",
    displayName: "CDF - Congolese Franc",
  },
  {
    name: "Swiss Franc",
    code: "CHF",
    symbol: "CHF",
    displayName: "CHF - Swiss Franc",
  },
  {
    name: "Chilean Unit of Account (UF)",
    code: "CLF",
    symbol: "UF",
    displayName: "CLF - Chilean Unit of Account (UF)",
  },
  {
    name: "Chilean Peso",
    code: "CLP",
    symbol: "$",
    displayName: "CLP - Chilean Peso",
  },
  {
    name: "Chinese Yuan (Offshore)",
    code: "CNH",
    symbol: "¥",
    displayName: "CNH - Chinese Yuan (Offshore)",
  },
  {
    name: "Chinese Yuan (Onshore)",
    code: "CNY",
    symbol: "¥",
    displayName: "CNY - Chinese Yuan (Onshore)",
  },
  {
    name: "Colombian Peso",
    code: "COP",
    symbol: "$",
    displayName: "COP - Colombian Peso",
  },
  {
    name: "Costa Rican Colón",
    code: "CRC",
    symbol: "₡",
    displayName: "CRC - Costa Rican Colón",
  },
  {
    name: "Cuban Convertible Peso",
    code: "CUC",
    symbol: "$",
    displayName: "CUC - Cuban Convertible Peso",
  },
  {
    name: "Cuban Peso",
    code: "CUP",
    symbol: "$",
    displayName: "CUP - Cuban Peso",
  },
  {
    name: "Cape Verdean Escudo",
    code: "CVE",
    symbol: "Esc",
    displayName: "CVE - Cape Verdean Escudo",
  },
  {
    name: "Czech Koruna",
    code: "CZK",
    symbol: "Kč",
    displayName: "CZK - Czech Koruna",
  },
  {
    name: "Djiboutian Franc",
    code: "DJF",
    symbol: "Fdj",
    displayName: "DJF - Djiboutian Franc",
  },
  {
    name: "Danish Krone",
    code: "DKK",
    symbol: "kr",
    displayName: "DKK - Danish Krone",
  },
  {
    name: "Dominican Peso",
    code: "DOP",
    symbol: "RD$",
    displayName: "DOP - Dominican Peso",
  },
  {
    name: "Algerian Dinar",
    code: "DZD",
    symbol: "دج",
    displayName: "DZD - Algerian Dinar",
  },
  {
    name: "Egyptian Pound",
    code: "EGP",
    symbol: "£",
    displayName: "EGP - Egyptian Pound",
  },
  {
    name: "Eritrean Nakfa",
    code: "ERN",
    symbol: "Nfk",
    displayName: "ERN - Eritrean Nakfa",
  },
  {
    name: "Ethiopian Birr",
    code: "ETB",
    symbol: "Br",
    displayName: "ETB - Ethiopian Birr",
  },
  { name: "Euro", code: "EUR", symbol: "€", displayName: "EUR - Euro" },
  {
    name: "Fijian Dollar",
    code: "FJD",
    symbol: "$",
    displayName: "FJD - Fijian Dollar",
  },
  {
    name: "Falkland Islands Pound",
    code: "FKP",
    symbol: "£",
    displayName: "FKP - Falkland Islands Pound",
  },
  {
    name: "British Pound Sterling",
    code: "GBP",
    symbol: "£",
    displayName: "GBP - British Pound Sterling",
  },
  {
    name: "Georgian Lari",
    code: "GEL",
    symbol: "₾",
    displayName: "GEL - Georgian Lari",
  },
  {
    name: "Guernsey Pound",
    code: "GGP",
    symbol: "£",
    displayName: "GGP - Guernsey Pound",
  },
  {
    name: "Ghanaian Cedi",
    code: "GHS",
    symbol: "GH₵",
    displayName: "GHS - Ghanaian Cedi",
  },
  {
    name: "Gibraltar Pound",
    code: "GIP",
    symbol: "£",
    displayName: "GIP - Gibraltar Pound",
  },
  {
    name: "Gambian Dalasi",
    code: "GMD",
    symbol: "D",
    displayName: "GMD - Gambian Dalasi",
  },
  {
    name: "Guinean Franc",
    code: "GNF",
    symbol: "FG",
    displayName: "GNF - Guinean Franc",
  },
  {
    name: "Guatemalan Quetzal",
    code: "GTQ",
    symbol: "Q",
    displayName: "GTQ - Guatemalan Quetzal",
  },
  {
    name: "Guyanaese Dollar",
    code: "GYD",
    symbol: "$",
    displayName: "GYD - Guyanaese Dollar",
  },
  {
    name: "Hong Kong Dollar",
    code: "HKD",
    symbol: "$",
    displayName: "HKD - Hong Kong Dollar",
  },
  {
    name: "Honduran Lempira",
    code: "HNL",
    symbol: "L",
    displayName: "HNL - Honduran Lempira",
  },
  {
    name: "Croatian Kuna",
    code: "HRK",
    symbol: "kn",
    displayName: "HRK - Croatian Kuna",
  },
  {
    name: "Haitian Gourde",
    code: "HTG",
    symbol: "G",
    displayName: "HTG - Haitian Gourde",
  },
  {
    name: "Hungarian Forint",
    code: "HUF",
    symbol: "Ft",
    displayName: "HUF - Hungarian Forint",
  },
  {
    name: "Indonesian Rupiah",
    code: "IDR",
    symbol: "Rp",
    displayName: "IDR - Indonesian Rupiah",
  },
  {
    name: "Israeli New Shekel",
    code: "ILS",
    symbol: "₪",
    displayName: "ILS - Israeli New Shekel",
  },
  {
    name: "Isle of Man Pound",
    code: "IMP",
    symbol: "£",
    displayName: "IMP - Isle of Man Pound",
  },
  {
    name: "Indian Rupee",
    code: "INR",
    symbol: "₹",
    displayName: "INR - Indian Rupee",
  },
  {
    name: "Iraqi Dinar",
    code: "IQD",
    symbol: "ع.د",
    displayName: "IQD - Iraqi Dinar",
  },
  {
    name: "Iranian Rial",
    code: "IRR",
    symbol: "﷼",
    displayName: "IRR - Iranian Rial",
  },
  {
    name: "Icelandic Króna",
    code: "ISK",
    symbol: "kr",
    displayName: "ISK - Icelandic Króna",
  },
  {
    name: "Jersey Pound",
    code: "JEP",
    symbol: "£",
    displayName: "JEP - Jersey Pound",
  },
  {
    name: "Jamaican Dollar",
    code: "JMD",
    symbol: "J$",
    displayName: "JMD - Jamaican Dollar",
  },
  {
    name: "Jordanian Dinar",
    code: "JOD",
    symbol: "د.ا",
    displayName: "JOD - Jordanian Dinar",
  },
  {
    name: "Japanese Yen",
    code: "JPY",
    symbol: "¥",
    displayName: "JPY - Japanese Yen",
  },
  {
    name: "Kenyan Shilling",
    code: "KES",
    symbol: "KSh",
    displayName: "KES - Kenyan Shilling",
  },
  {
    name: "Kyrgyzstani Som",
    code: "KGS",
    symbol: "som",
    displayName: "KGS - Kyrgyzstani Som",
  },
  {
    name: "Cambodian Riel",
    code: "KHR",
    symbol: "៛",
    displayName: "KHR - Cambodian Riel",
  },
  {
    name: "Comorian Franc",
    code: "KMF",
    symbol: "CF",
    displayName: "KMF - Comorian Franc",
  },
  {
    name: "North Korean Won",
    code: "KPW",
    symbol: "₩",
    displayName: "KPW - North Korean Won",
  },
  {
    name: "South Korean Won",
    code: "KRW",
    symbol: "₩",
    displayName: "KRW - South Korean Won",
  },
  {
    name: "Kuwaiti Dinar",
    code: "KWD",
    symbol: "د.ك",
    displayName: "KWD - Kuwaiti Dinar",
  },

  {
    name: "Cayman Islands Dollar",
    code: "KYD",
    symbol: "$",
    displayName: "KYD - Cayman Islands Dollar",
  },
  {
    name: "Kazakhstani Tenge",
    code: "KZT",
    symbol: "₸",
    displayName: "KZT - Kazakhstani Tenge",
  },
  { name: "Lao Kip", code: "LAK", symbol: "₭", displayName: "LAK - Lao Kip" },
  {
    name: "Lebanese Pound",
    code: "LBP",
    symbol: "ل.ل",
    displayName: "LBP - Lebanese Pound",
  },
  {
    name: "Sri Lankan Rupee",
    code: "LKR",
    symbol: "Rs",
    displayName: "LKR - Sri Lankan Rupee",
  },
  {
    name: "Liberian Dollar",
    code: "LRD",
    symbol: "$",
    displayName: "LRD - Liberian Dollar",
  },
  {
    name: "Lesotho Loti",
    code: "LSL",
    symbol: "L",
    displayName: "LSL - Lesotho Loti",
  },
  {
    name: "Libyan Dinar",
    code: "LYD",
    symbol: "ل.د",
    displayName: "LYD - Libyan Dinar",
  },
  {
    name: "Moroccan Dirham",
    code: "MAD",
    symbol: "د.م.",
    displayName: "MAD - Moroccan Dirham",
  },
  {
    name: "Moldovan Leu",
    code: "MDL",
    symbol: "lei",
    displayName: "MDL - Moldovan Leu",
  },
  {
    name: "Malagasy Ariary",
    code: "MGA",
    symbol: "Ar",
    displayName: "MGA - Malagasy Ariary",
  },
  {
    name: "Macedonian Denar",
    code: "MKD",
    symbol: "ден",
    displayName: "MKD - Macedonian Denar",
  },
  {
    name: "Myanmar Kyat",
    code: "MMK",
    symbol: "K",
    displayName: "MMK - Myanmar Kyat",
  },
  {
    name: "Mongolian Tögrög",
    code: "MNT",
    symbol: "₮",
    displayName: "MNT - Mongolian Tögrög",
  },
  {
    name: "Macanese Pataca",
    code: "MOP",
    symbol: "P",
    displayName: "MOP - Macanese Pataca",
  },
  {
    name: "Mauritanian Ouguiya",
    code: "MRU",
    symbol: "UM",
    displayName: "MRU - Mauritanian Ouguiya",
  },
  {
    name: "Mauritian Rupee",
    code: "MUR",
    symbol: "₨",
    displayName: "MUR - Mauritian Rupee",
  },
  {
    name: "Maldivian Rufiyaa",
    code: "MVR",
    symbol: ".ރ",
    displayName: "MVR - Maldivian Rufiyaa",
  },
  {
    name: "Malawian Kwacha",
    code: "MWK",
    symbol: "MK",
    displayName: "MWK - Malawian Kwacha",
  },
  {
    name: "Mexican Peso",
    code: "MXN",
    symbol: "$",
    displayName: "MXN - Mexican Peso",
  },
  {
    name: "Malaysian Ringgit",
    code: "MYR",
    symbol: "RM",
    displayName: "MYR - Malaysian Ringgit",
  },
  {
    name: "Mozambican Metical",
    code: "MZN",
    symbol: "MTn",
    displayName: "MZN - Mozambican Metical",
  },
  {
    name: "Namibian Dollar",
    code: "NAD",
    symbol: "$",
    displayName: "NAD - Namibian Dollar",
  },
  {
    name: "Nigerian Naira",
    code: "NGN",
    symbol: "₦",
    displayName: "NGN - Nigerian Naira",
  },
  {
    name: "Nicaraguan Córdoba Oro",
    code: "NIO",
    symbol: "C$",
    displayName: "NIO - Nicaraguan Córdoba Oro",
  },
  {
    name: "Norwegian Krone",
    code: "NOK",
    symbol: "kr",
    displayName: "NOK - Norwegian Krone",
  },
  {
    name: "Nepalese Rupee",
    code: "NPR",
    symbol: "₨",
    displayName: "NPR - Nepalese Rupee",
  },
  {
    name: "New Zealand Dollar",
    code: "NZD",
    symbol: "$",
    displayName: "NZD - New Zealand Dollar",
  },
  {
    name: "Omani Rial",
    code: "OMR",
    symbol: "ر.ع.",
    displayName: "OMR - Omani Rial",
  },
  {
    name: "Panamanian Balboa",
    code: "PAB",
    symbol: "B/.",
    displayName: "PAB - Panamanian Balboa",
  },
  {
    name: "Peruvian Sol",
    code: "PEN",
    symbol: "S/.",
    displayName: "PEN - Peruvian Sol",
  },
  { name: "Papua", code: "PGK", symbol: "K", displayName: "PGK - Papua" },
  {
    name: "Philippine Peso",
    code: "PHP",
    symbol: "₱",
    displayName: "PHP - Philippine Peso",
  },
  {
    name: "Pakistani Rupee",
    code: "PKR",
    symbol: "₨",
    displayName: "PKR - Pakistani Rupee",
  },
  {
    name: "Polish Zloty",
    code: "PLN",
    symbol: "zł",
    displayName: "PLN - Polish Zloty",
  },
  {
    name: "Paraguayan Guarani",
    code: "PYG",
    symbol: "₲",
    displayName: "PYG - Paraguayan Guarani",
  },
  {
    name: "Qatari Riyal",
    code: "QAR",
    symbol: "﷼",
    displayName: "QAR - Qatari Riyal",
  },
  {
    name: "Romanian Leu",
    code: "RON",
    symbol: "lei",
    displayName: "RON - Romanian Leu",
  },
  {
    name: "Serbian Dinar",
    code: "RSD",
    symbol: "din",
    displayName: "RSD - Serbian Dinar",
  },
  {
    name: "Russian Ruble",
    code: "RUB",
    symbol: "₽",
    displayName: "RUB - Russian Ruble",
  },
  {
    name: "Rwandan Franc",
    code: "RWF",
    symbol: "Fr",
    displayName: "RWF - Rwandan Franc",
  },
  {
    name: "Saudi Riyal",
    code: "SAR",
    symbol: "﷼",
    displayName: "SAR - Saudi Riyal",
  },
  {
    name: "Solomon Islands Dollar",
    code: "SBD",
    symbol: "$",
    displayName: "SBD - Solomon Islands Dollar",
  },
  {
    name: "Seychellois Rupee",
    code: "SCR",
    symbol: "₨",
    displayName: "SCR - Seychellois Rupee",
  },
  {
    name: "Sudanese Pound",
    code: "SDG",
    symbol: "ج.س.",
    displayName: "SDG - Sudanese Pound",
  },
  {
    name: "Swedish Krona",
    code: "SEK",
    symbol: "kr",
    displayName: "SEK - Swedish Krona",
  },
  {
    name: "Singapore Dollar",
    code: "SGD",
    symbol: "$",
    displayName: "SGD - Singapore Dollar",
  },
  {
    name: "Saint Helena Pound",
    code: "SHP",
    symbol: "£",
    displayName: "SHP - Saint Helena Pound",
  },
  {
    name: "Sierra Leonean Leone",
    code: "SLL",
    symbol: "Le",
    displayName: "SLL - Sierra Leonean Leone",
  },
  {
    name: "Somali Shilling",
    code: "SOS",
    symbol: "S",
    displayName: "SOS - Somali Shilling",
  },
  {
    name: "Surinamese Dollar",
    code: "SRD",
    symbol: "$",
    displayName: "SRD - Surinamese Dollar",
  },
  {
    name: "South Sudanese Pound",
    code: "SSP",
    symbol: "£",
    displayName: "SSP - South Sudanese Pound",
  },
  {
    name: "São Tomé and Príncipe Dobra",
    code: "STD",
    symbol: "Db",
    displayName: "STD - São Tomé and Príncipe Dobra",
  },
  {
    name: "São Tomé and Príncipe Dobra",
    code: "STN",
    symbol: "Db",
    displayName: "STN - São Tomé and Príncipe Dobra",
  },
  {
    name: "Salvadoran Colón",
    code: "SVC",
    symbol: "$",
    displayName: "SVC - Salvadoran Colón",
  },
  {
    name: "Syrian Pound",
    code: "SYP",
    symbol: "£",
    displayName: "SYP - Syrian Pound",
  },
  {
    name: "Swazi Lilangeni",
    code: "SZL",
    symbol: "E",
    displayName: "SZL - Swazi Lilangeni",
  },
  {
    name: "Thai Baht",
    code: "THB",
    symbol: "฿",
    displayName: "THB - Thai Baht",
  },
  {
    name: "Tajikistani Somoni",
    code: "TJS",
    symbol: "ЅМ",
    displayName: "TJS - Tajikistani Somoni",
  },
  {
    name: "Turkmenistani Manat",
    code: "TMT",
    symbol: "m",
    displayName: "TMT - Turkmenistani Manat",
  },
  {
    name: "Tunisian Dinar",
    code: "TND",
    symbol: "د.ت.",
    displayName: "TND - Tunisian Dinar",
  },
  {
    name: "Tongan Paʻanga",
    code: "TOP",
    symbol: "T$",
    displayName: "TOP - Tongan Paʻanga",
  },
  {
    name: "Turkish Lira",
    code: "TRY",
    symbol: "₺",
    displayName: "TRY - Turkish Lira",
  },
  {
    name: "Trinidad and Tobago Dollar",
    code: "TTD",
    symbol: "$",
    displayName: "TTD - Trinidad and Tobago Dollar",
  },
  {
    name: "New Taiwan Dollar",
    code: "TWD",
    symbol: "$",
    displayName: "TWD - New Taiwan Dollar",
  },
  {
    name: "Tanzanian Shilling",
    code: "TZS",
    symbol: "Sh",
    displayName: "TZS - Tanzanian Shilling",
  },
  {
    name: "Ukrainian Hryvnia",
    code: "UAH",
    symbol: "₴",
    displayName: "UAH - Ukrainian Hryvnia",
  },
  {
    name: "Ugandan Shilling",
    code: "UGX",
    symbol: "Sh",
    displayName: "UGX - Ugandan Shilling",
  },
  {
    name: "United States Dollar",
    code: "USD",
    symbol: "$",
    displayName: "USD - United States Dollar",
  },
  {
    name: "Uruguayan Peso",
    code: "UYU",
    symbol: "$",
    displayName: "UYU - Uruguayan Peso",
  },
  {
    name: "Uzbekistan Som",
    code: "UZS",
    symbol: "so'm",
    displayName: "UZS - Uzbekistan Som",
  },
  {
    name: "Venezuelan Bolívar Soberano",
    code: "VES",
    symbol: "Bs.S.",
    displayName: "VES - Venezuelan Bolívar Soberano",
  },
  {
    name: "Vietnamese Dong",
    code: "VND",
    symbol: "₫",
    displayName: "VND - Vietnamese Dong",
  },
  {
    name: "Vanuatu Vatu",
    code: "VUV",
    symbol: "Vt",
    displayName: "VUV - Vanuatu Vatu",
  },
  {
    name: "Samoan Tala",
    code: "WST",
    symbol: "T",
    displayName: "WST - Samoan Tala",
  },
  {
    name: "Central African CFA Franc",
    code: "XAF",
    symbol: "Fr",
    displayName: "XAF - Central African CFA Franc",
  },
  {
    name: "Silver (troy ounce)",
    code: "XAG",
    symbol: "oz t",
    displayName: "XAG - Silver (troy ounce)",
  },
  {
    name: "Gold (troy ounce)",
    code: "XAU",
    symbol: "oz t",
    displayName: "XAU - Gold (troy ounce)",
  },
  {
    name: "East Caribbean Dollar",
    code: "XCD",
    symbol: "$",
    displayName: "XCD - East Caribbean Dollar",
  },
  {
    name: "Special Drawing Rights (International Monetary Fund)",
    code: "XDR",
    symbol: "-",
    displayName: "XDR - Special Drawing Rights (International Monetary Fund)",
  },
  {
    name: "West African CFA Franc",
    code: "XOF",
    symbol: "Fr",
    displayName: "XOF - West African CFA Franc",
  },
  {
    name: "Palladium (troy ounce)",
    code: "XPD",
    symbol: "oz t",
    displayName: "XPD - Palladium (troy ounce)",
  },
  {
    name: "CFP franc",
    code: "XPF",
    symbol: "F",
    displayName: "XPF - CFP franc",
  },
  { name: "Platinum", code: "XPT", symbol: "", displayName: "XPT - Platinum" },
  {
    name: "Yemeni rial",
    code: "YER",
    symbol: "﷼",
    displayName: "YER - Yemeni rial",
  },
  {
    name: "South African rand",
    code: "ZAR",
    symbol: "R",
    displayName: "ZAR - South African rand",
  },
  {
    name: "Zambian kwacha",
    code: "ZMW",
    symbol: "ZK",
    displayName: "ZMW - Zambian kwacha",
  },
  {
    name: "Zimbabwean dollar (defunct since 2009; replaced by USD, ZAR)",
    code: "ZWL",
    symbol: "$, zwd",
    displayName:
      "ZWL - Zimbabwean dollar (defunct since 2009; replaced by USD, ZAR)",
  },
];

export const CoversionFactorCMToUnits = {
  m: 0.01,
  inch: 0.393701,
  ft: 0.0328084,
  mm: 10,
  cm: 1,
};

export const CoversionFactorUnitsToCM = {
  m: 100,
  inch: 2.54,
  ft: 30.48,
  mm: 0.1,
  cm: 1,
};

export const conversionFactorUnitsToTonne = {
  kg: 0.001,
  g: 0.000001,
  t: 1,
  ton: 0.907185,
  lb: 0.000454,
  ounce: 0.0000283495,
  stone: 0.00635029,
  imperial_ton: 1.01605
};

export const weight_Unit_Conversions = {
    kg: "0.001",
    g: "0.000001",
    t: "1",
    ton: "0.907185",
    lb: "0.000454",
    ounce: "0.00002835",
    stone: "0.00635029",
    imperial_ton: "1.01605",
};

export const conversionFactorTonneToUnits   = {
  kg: 1000,
  g: 1000000,
  t: 1,
  ton: 1.10231,
  lb: 2202.64317,
  ounce: 35273.9619,
  stone: 157.473,
  imperial_ton: 0.984207,
};

export const orderDim_Rewinder_Unit_Conversion = {
    cm: "1",
    mm: "0.1",
    m: "100",
    inch: "2.54",
    ft: "30.48",
};

export const WEIGHT_CONVERSION_FACTORS ={
  "g": {
      "g": 1,
      "kg": 0.001,
      "t": 0.000001,
      "ton": 0.00000110231,
      "imperial_ton": 0.000000984207,
      "lb": 0.00220462
  },
  "kg": {
      "g": 1000,
      "kg": 1,
      "t": 0.001,
      "ton": 0.00110231,
      "imperial_ton": 0.000984207,
      "lb": 2.20462
  },
  "t": {
      "g": 1000000,
      "kg": 1000,
      "t": 1,
      "ton": 1.10231,
      "imperial_ton": 0.984207,
      "lb": 2204.62
  },
  "ton": {
      "g": 907185,
      "kg": 907.185,
      "t": 0.907185,
      "ton": 1,
      "imperial_ton": 0.892857,
      "lb": 2000
  },
  "imperial_ton": {
      "g": 1016047,
      "kg": 1016.047,
      "t": 1.016047,
      "ton": 1.12,
      "imperial_ton": 1,
      "lb": 2240
  },
  "lb": {
      "g": 453.592,
      "kg": 0.453592,
      "t": 0.000453592,
      "ton": 0.0005,
      "imperial_ton": 0.000446429,
      "lb": 1
  }
}


export const CONVERSION_FORMULAS = {
  "weight":{
      "t": 1,
      "kg": 1000,
      "g": 1000000,  
      "ton": 1.10231,
      "imperial_ton": 0.984207,
      "lb": 2204.62,
      "ounce": 35274,
      "stone": 157.473,
  },
  "length":{
      "cm": 1,
      "mm": 10,
      "m": 0.01,
      "inch": 0.393700787,
      "ft": 0.032808399,
      "km": 0.00001,
      "mile": 0.000006215,
      "yard": 0.010936133,
      "inch": 0.393700787
  }
}

export const LENGTH_CONVERSION_FACTORS = {
  "mm": {
      "mm": 1,
      "cm": 0.1,
      "m": 0.001,
      "inch": 0.0393701,
      "ft": 0.00328084
  },
  "cm": {
      "mm": 10,
      "cm": 1,
      "m": 0.01,
      "inch": 0.393701,
      "ft": 0.032808399
  },
  "m": {
      "mm": 1000,
      "cm": 100,
      "m": 1,
      "inch": 39.3701,
      "ft": 3.28084
  },
  "inch": {
      "mm": 25.4,
      "cm": 2.54,
      "m": 0.0254,
      "inch": 1,
      "ft": 0.0833333
  },
  "ft": {
      "mm": 304.8,
      "cm": 30.48,
      "m": 0.3048,
      "inch": 12,
      "ft": 1
  }
}
